<template>
  <b-modal
    ref="modal"
    :title="modalTitle"
    size="lg"
    centered
    scrollable
    no-close-on-backdrop
    header-border-variant="none"
    @hidden="onModalHidden"
  >
    <div class="duplicate-recall-content">
      <div v-html="bodyContent"></div>
    </div>

    <template v-slot:modal-footer>
      <b-button
        variant="outline-secondary"
        @click="handleCancel"
        class="option-btn"
      >
        No
      </b-button>
      <b-button
        variant="primary"
        @click="handleConfirm"
        class="option-btn"
        :disabled="!confirmChecked"
      >
        Yes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
    name: 'DuplicateRecallModal',
    data() {
        return {
            modalTitle: 'Duplicate Recall Confirmation',
            bodyContent: '',
            resolvePromise: null,
            confirmChecked: false
        }
    },
    methods: {
        show(content) {
            this.bodyContent = content
            this.confirmChecked = false
            this.$refs.modal.show()

            // Set up checkbox listener after content is updated
            this.$nextTick(() => {
                this.setupCheckboxListener()
            })

            return new Promise((resolve) => {
                this.resolvePromise = resolve
            })
        },

        handleConfirm() {
            this.$refs.modal.hide()
            if (this.resolvePromise) {
                this.resolvePromise(true)
            }
        },

        handleCancel() {
            this.$refs.modal.hide()
            if (this.resolvePromise) {
                this.resolvePromise(false)
            }
        },

        onModalHidden() {
            // Clean up if modal is closed without clicking buttons
            if (this.resolvePromise) {
                this.resolvePromise(false)
                this.resolvePromise = null
            }
            this.confirmChecked = false
        },

        setupCheckboxListener() {
            const checkbox = document.getElementById('confirmDuplicate')
            if (checkbox) {
                checkbox.addEventListener('change', (event) => {
                    this.confirmChecked = event.target.checked
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.option-btn {
  width: 80px;
  margin-left: 10px;
}

.duplicate-recall-content {
  .duplicate-list {
    border: 1px solid #ddd;
    padding: 15px;
    background-color: #f9f9f9;
    border-radius: 4px;
    margin: 15px 0;
  }

  .duplicate-item {
    margin-bottom: 12px;
    padding: 8px;
    border-left: 3px solid #007bff;
    background-color: #fff;
  }

  .recall-name {
    font-weight: bold;
    color: #333;
  }

  .recall-details {
    color: #666;
    font-size: 0.9em;
    margin-top: 4px;
  }
}

::v-deep .modal-content {
  width: 100% !important;
}

::v-deep .modal-title {
  color: #009efb !important;
  font-weight: 600;
}
</style>